// Project.js (or projects.js)

// Import your actual image files here if you are using Webpack/Vite (recommended)
// import tamilManamalaiImage from './assets/images/tamilmanamalai.jpg'; 
// import ecommerceImage from './assets/images/ecommerce.jpg'; 
// import studentDBImage from './assets/images/studentdb.jpg'; 

const projectsData = [
  {
    id: 1,
    name: "Tamil Manamalai Trust Website",
    description: "A comprehensive informational and functional website for the Tamil Manamalai Trust, featuring donation/trust-related pages and secure payment integration.",
    tech: ["React", "Spring Boot", "PostgreSQL", "Payment Gateway"],
    demo: "https://tamilmanamalaitrust.com/",
    github: "#", 
    // 🔥 CRITICAL ADDITION: Image Path/URL
    imageUrl: "/logo1.jpg", // Use a static path or imported variable
  },
  {
    id: 2,
    name: "E-Commerce Platform",
    description: "A full-featured e-commerce website complete with product listings, a shopping cart, a secure payment gateway, and a dedicated administrator control panel.",
    tech: ["React", "Spring Boot", "MySQL", "Payment Gateway", "Admin Panel"],
    demo: "https://cashewvault.blogspot.com/?m=0", 
    github: "#", 
    // 🔥 CRITICAL ADDITION: Image Path/URL
    imageUrl: "/logo2.jpg",
  },
  {
    id: 3,
    name: "Student Database & Grading System",
    description: "A centralized system for managing student records, viewing marks, calculating grades, and providing reporting access for parents/guardians.",
    tech: ["PHP", "MySQL", "Excel Integration"],
    demo: "https://studentlogin.wuaze.com/?i=1", 
    github: "#", 
    // 🔥 CRITICAL ADDITION: Image Path/URL
    imageUrl: "/logo3.jpg",
  },
];

export default projectsData;